import React from "react";
import { observer } from "mobx-react-lite";

import DataGrid from "../datatable/DataGrid";
import { DataGridStorage } from "../datatable/DataGridStorage";

export interface DialogGridProps {
  itemTypeKey: string;
  dataGridStorage: DataGridStorage;
  singleSelection?: boolean;
}

const DialogGrid = observer((props: DialogGridProps) => {
  const { itemTypeKey, dataGridStorage, singleSelection = false } = props;

  return (
    <div className="dialog-table-container">
      <DataGrid
        itemTypeKey={itemTypeKey}
        dataGridStorage={dataGridStorage}
        insideDialog
        singleSelection={singleSelection}
      />
    </div>
  );
});

export default DialogGrid;
